import React from "react";

import {bindActionCreators} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Pagination} from 'antd';
import {Row, Col, Select, Checkbox, message, Spin, Input} from 'antd';

import "./index.scss";
import CloudFlyerAPI from "../../api/CloudFlyerAPI";
import {receiveError} from "../../api/http";

const {Option} = Select;

const {Search} = Input;

class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false, getNotificationData: [], usersList: [], pageSize: 50, page: 1, total: 0, assignTask: [], leftside: [], leftSearchSide: [], rightSide: [], rightSearchSide: [], checkedLeftSide: [], checkedRightSide: [], selectedEvent: "", dataSaved: false,
            rightSearchVal: "",
            leftSearchVal: ""
        };
        this.onChangeLeft = this.onChangeLeft.bind(this);
        this.onChangeRight = this.onChangeRight.bind(this);
        this.onLeftSearch = this.onLeftSearch.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.onLeftSearchUpdate = this.onLeftSearchUpdate.bind(this);
        this.onRightSearch = this.onRightSearch.bind(this);

    }

    onChangeLeft(checkedValues) {
        console.log(checkedValues, "checkedValues")
        this.setState({
            checkedLeftSide: checkedValues
        })

    }

    onChangeRight(checkedValues) {
        this.setState({
            checkedRightSide: checkedValues
        })
    }

    onLeftSearch() {
        console.log(this.state)
        this.setState({
            page:1
        })
        if(this.state.leftSearchVal !== ''){
            this.handleChangePage(this.state.selectedEvent, 1, this.state.leftSearchVal);
        }else{
            this.handleChangePage(this.state.selectedEvent, 1)
        }
    }

    onLeftSearchUpdate(value) {
        var val = "";
        if (value !== "") {
            val = value.target.value
        }
        this.setState({
            leftSearchVal: val
        })
    }

    onRightSearch(value) {
        var val = "";
        if (value !== "") {
            val = value.target.value
        }
        var pushRightSide = [];
        for (let i = this.state.rightSearchSide.length - 1; i >= 0; i--) {
            if (this.state.rightSearchSide[i].toLowerCase().indexOf(val.toLowerCase()) !== -1) {
                pushRightSide.push(this.state.rightSearchSide[i])
            }
        }
        this.setState({
            rightSide: pushRightSide,
            rightSearchVal: val
        })
    }

    componentDidMount() {

        this.getDropdown()

    }

    getDropdown() {

        this.setState({
            loading: true, leftside: [], rightSide: [], checkedLeftSide: [], checkedRightSide: []
        });

        CloudFlyerAPI.report_admin
            .getNotifications()
            .then(({data}) => {
                this.setState({
                    getNotificationData: data, loading: false,
                });

            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    }

    getMatch(value, emptyRight = false) {
        console.log(value, "dropdown value 2")
        var events = this.state.getNotificationData;
        var users = this.state.usersList;
        var selectedEventData = [];
        selectedEventData.users = [];
        var leftData = [];

        var rightData = this.state.rightSide;
        console.log(rightData)
        console.log("*********************************")
        console.log(rightData)
        console.log(emptyRight)
        for (let i = 0; i < events.length; i++) {
            if (events[i].users.length > 0 && events[i].eventName === value) {
                selectedEventData = events[i];
                break;
            }
        }
        console.log(selectedEventData, "selectedEventData");

        if(emptyRight === true){
            rightData = [];
            console.log("emptyRight");

            for (let i = 0; i < selectedEventData.users.length; i++) {
                if ( rightData.findIndex(x => x === selectedEventData.users[i]) === -1){
                    rightData.push(selectedEventData.users[i]);
                }
            }
        }

        for (var e = 0; e < users.length; e++) {
            var matched = false;

            for (let i = 0; i < selectedEventData.users.length; i++) {
                if (users[e].username === selectedEventData.users[i]) {
                    if ( rightData.findIndex(x => x === users[e].username) === -1){
                        rightData.push(users[e].username);
                    }
                    matched = true;
                }
            }
            if (!matched) {
                leftData.push(users[e].username)
            }
        }

        console.log(leftData, "leftData")
        console.log(rightData, "rightData")
        this.setState({
            loading: false, leftSide: leftData, leftSearchSide: leftData, rightSide: rightData, rightSearchSide: rightData
        })


    }

    addNotifications() {
        var users = this.state.usersList;
        var leftData = this.state.leftSide;
        var leftSearchSide = this.state.leftSearchSide;
        var rightData = this.state.rightSide;
        var rightSearchSide = this.state.rightSearchSide;
        for (var e = 0; e < users.length; e++) {
            for (let i = 0; i < this.state.checkedLeftSide.length; i++) {
                if (users[e].username === this.state.checkedLeftSide[i]) {
                    //rightData.push(users[e]);
                    rightSearchSide.push(users[e].username);
                    break;
                }
            }
        }
        console.log(this.checkedLeftSide)
        var _this = this;
        for (let i = 0; i < this.state.checkedLeftSide.length; i++) {
            var index = leftData.findIndex(function (o) {
                return o === _this.state.checkedLeftSide[i];
            });
            if (index !== -1) leftData.splice(index, 1);
        }
        for (let i = 0; i < this.state.checkedLeftSide.length; i++) {
            var index1 = leftSearchSide.findIndex(function (o) {
                return o === _this.state.checkedLeftSide[i];
            });
            if (index1 !== -1) leftSearchSide.splice(index1, 1);
        }
        this.setState({
            loading: false, leftSide: leftData, leftSearchSide: leftSearchSide, rightSearchSide: rightSearchSide, rightSide: rightData, checkedLeftSide: [], checkedRightSide: [],
            leftSearchVal: "",
            rightSearchVal: ""
        })
        //this.onLeftSearch("");
       // this.onRightSearch("");
    }

    removeNotifications() {
        var users = this.state.usersList;
        var leftData = this.state.leftSide;
        var rightData = this.state.rightSide;
        var rightSearchSide = this.state.rightSearchSide;
        var leftSearchSide = this.state.leftSearchSide;
        for (var e = 0; e < users.length; e++) {
            for (let i = 0; i < this.state.checkedRightSide.length; i++) {
                if (users[e].username === this.state.checkedRightSide[i]) {
                    //leftData.push(users[e]);
                    leftSearchSide.push(users[e].username);
                    break;
                }
            }
        }

        var _this = this;
        for (let i = 0; i < this.state.checkedRightSide.length; i++) {
            var index = rightData.findIndex(function (o) {
                return o === _this.state.checkedRightSide[i];
            });
            if (index !== -1) rightData.splice(index, 1);
        }

        for (let i = 0; i < this.state.checkedRightSide.length; i++) {
            var index1 = rightSearchSide.findIndex(function (o) {
                return o === _this.state.checkedRightSide[i];
            });
            if (index1 !== -1) rightSearchSide.splice(index1, 1);
        }
        this.setState({
            loading: false, leftSide: leftData, rightSearchSide: rightSearchSide, leftSearchSide: leftSearchSide, rightSide: rightData, checkedLeftSide: [], checkedRightSide: [],
            leftSearchVal: "",
            rightSearchVal: ""
        })

        //this.onLeftSearch("");
       // this.onRightSearch("");
    }


    handleChange(value) {
        if (value !== null) {
            this.setState({clicked: true});
        }

        this.setState({
            loading: true, leftside: [], rightSide: [], checkedLeftSide: [], checkedRightSide: [], page: 1
        })
        this.setState({})
        CloudFlyerAPI.report_admin
            .fetchAllUsersWithPagination(50, 1)
            .then(({data}) => {
                console.log(value);
                console.log(data);
                this.setState({
                    loading: false, usersList: data.data, pageSize: data?.options?.pageSize, page: data?.options?.page, total: data?.total, selectedEvent: value
                });

                console.log(this.state.pageSize)
                console.log(this.state.page)
                console.log(this.state.total)
                console.log(this.state.getNotificationData)

                this.getMatch(value,true)

            })
            .catch(err => {
                const msg = receiveError(null, err).message

            })
    }

    handleChangePage(value, page = 1, username = null) {
        if (value !== null) {
            this.setState({clicked: true});
        }

        this.setState({
            loading: true, leftside: [], checkedLeftSide: []
        })
        if (username === null) {
            CloudFlyerAPI.report_admin
                .fetchAllUsersWithPagination(50, page)
                .then(({data}) => {
                    console.log(data);
                    this.setState({
                        loading: false, usersList: data.data, pageSize: data?.options?.pageSize, page: data?.options?.page, total: data?.total, selectedEvent: value
                    });

                    console.log(this.state.pageSize)
                    console.log(this.state.page)
                    console.log(this.state.total)

                    this.getMatch(value, false)

                })
                .catch(err => {
                    const msg = receiveError(null, err).message

                })
        } else {
            console.log(username)

            CloudFlyerAPI.report_admin
                .fetchAllUsersWithPaginationWithUsername(50, page, username)
                .then(({data}) => {
                    console.log(data);
                    this.setState({
                        loading: false, usersList: data.data, pageSize: data?.options?.pageSize, page: data?.options?.page, total: data?.total, selectedEvent: value
                    });

                    console.log(this.state.pageSize)
                    console.log(this.state.page)
                    console.log(this.state.total)
                    console.log(this.state.leftSearchVal)
                    console.log(this.state.rightSearchVal)

                    this.getMatch(value, false)

                })
                .catch(err => {
                    const msg = receiveError(null, err).message

                })
        }
        console.log(this.state)
    }
    setNotifications(e) {
        e.preventDefault();
        this.setState({
            loading: true,
        });

        var events = this.state.getNotificationData;
        var event = {};
        for (let i = 0; i < events.length; i++) {
            if (events[i].eventName === this.state.selectedEvent) {
                event = events[i];
                break;
            }
        }
        var users = [];
        for (var i = 0; i < this.state.rightSide.length; i++) {
            users.push(this.state.rightSide[i])
        }
        const filter = {
            eventName: event.eventName, eventDescription: event.eventDescription, eventSubscriber: 1, users: users
        }
        CloudFlyerAPI.report_admin
            .postNotifications(filter, {
                data: JSON.stringify(filter), headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("Authorization"), 'Content-Type': 'application/json', 'accept': '*/*',
                }
            })
            .then(({data}) => {
                this.setState({
                    loading: false, checkedLeftSide: [], checkedRightSide: []
                });
                message.success('Set Notifications saved successfully.');

                CloudFlyerAPI.report_admin
                    .getNotifications()
                    .then(({data}) => {
                        this.setState({
                            getNotificationData: data, loading: false,
                        });

                    })
                    .catch((err) => {
                        const msg = receiveError(null, err).message;
                    });

            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    }

    onChangePage = page => {
        console.log(page);
        console.log(this.state.selectedEvent);

        this.setState({
            loading: true, page: page
        });

        if(this.state.leftSearchVal !== ''){
            this.handleChangePage(this.state.selectedEvent, page, this.state.leftSearchVal);
        }else{
            this.handleChangePage(this.state.selectedEvent, page)
        }
    };

    render() {

        let noAssignTask = this.state?.leftSide?.map((t, index) => {
            return {
                key: index, label: t, value: t,
            }
        });
        let assigned = this.state?.rightSide?.map((t, index) => {
            return {
                key: index, label: t, value: t,
            }
        });
        return (<div className="usersListDashboard">
            <div className="header">
                <div className="left-wrapper">
                    <h2>Notifications</h2>
                </div>
                <div className="right-wrapper">
                    <div className="active-jobs-wrapper-sync">
                    </div>
                </div>
            </div>
            <Spin spinning={this.state.loading}>
                <div className="notifications">
                    <label htmlFor="events">Choose Event</label>
                    <Select id="events" defaultValue="Please Select One" style={{width: 300}}
                            onChange={(value) => this.handleChange(value)}>
                        {this.state.getNotificationData.map((data, index) => (<Option key={index} value={data.eventName}>{data.eventDescription}</Option>))}
                    </Select>
                    <Row id="notification-hide" className={this.state.clicked ? 'notification-show' : 'false'}>
                        <Col span={6} xs={{order: 1}} sm={{order: 2}} md={{order: 3}} lg={{order: 4}}>
                            <h3>No Assign</h3>
                            <div className="tasks-search">
                                <Search
                                    placeholder="Search..."
                                    onSearch={this.onLeftSearch}
                                    value={this.state.leftSearchVal}
                                    onChange={this.onLeftSearchUpdate}
                                />
                            </div>
                            <div className="checkWrapper">
                                <Checkbox.Group options={noAssignTask} value={this.state.checkedLeftSide} onChange={this.onChangeLeft}/>
                            </div>
                        </Col>
                        <Col span={4} xs={{order: 2}} sm={{order: 1}} md={{order: 4}} lg={{order: 3}}>

                            <div className="add-notification-button" onClick={e => this.addNotifications(e)}>Add</div>
                            <div className="remove-notification-button" onClick={e => this.removeNotifications(e)}>Remove</div>

                        </Col>
                        <Col span={6} xs={{order: 3}} sm={{order: 4}} md={{order: 2}} lg={{order: 1}}>
                            <div className="set-notification">
                                <a href="#" className="btn-style" onClick={e => this.setNotifications(e)}>Set Notifications</a>
                            </div>
                            <h3>Assign</h3>
                            <div className="tasks-search">
                                <Search
                                    placeholder="Search..."
                                    // onSearch={this.onRightSearch}
                                    value={this.state.rightSearchVal}
                                    onChange={this.onRightSearch}
                                />
                            </div>
                            <div className="checkWrapper">
                                <Checkbox.Group options={assigned} value={this.state.checkedRightSide} onChange={this.onChangeRight}/>
                            </div>
                        </Col>
                        <Col span={12}>
                            <Pagination current={this.state.page} onChange={this.onChangePage} total={this.state.total} pageSize={this.state.pageSize}/>
                        </Col>
                    </Row>
                </div>
            </Spin>
        </div>);
    }
}

export default withRouter(connect(({auth}) => {
    let user = auth.user;
    return {
        ...user,
    };
}, (dispatch) => bindActionCreators({}, dispatch))(Notifications));
